/**
 * The Firebase web app configuration, from M-11.
 *
 * This is NOT a secret and is committed like any other config. The `apiKey` identifies
 * the project to Firebase; it authorises nothing. What a browser may read and write is
 * decided entirely by `firestore.rules`, proven in B-07 — a signed-in browser reaches
 * exactly one user's own documents, and `phoneIndex` and `magicLinks` are reachable by
 * nobody. Everything in M-10 is the opposite and never appears in this repo (C-04).
 */
export const firebaseConfig = {
  apiKey: "AIzaSyDDWXuCj2vPHidRXrZwLwNgRoLKkzRjgUc",
  authDomain: "altrtrack.firebaseapp.com",
  projectId: "altrtrack",
  storageBucket: "altrtrack.firebasestorage.app",
  messagingSenderId: "923713976237",
  appId: "1:923713976237:web:82b8c44939cedf00809324",
};

/**
 * The console also offers `measurementId` and a Google Analytics snippet. Both are left
 * out: this is a single-user personal log, and shipping an analytics SDK to measure one
 * person using their own gym data would be all cost and no answer.
 */
